module.exports = __webpack_public_path__ + "img/chevron-up-white.6c1067cf.svg";